import { RoleType } from '@/API';
import { UsersIcon } from '@/components/Icons/CommonIcons';
import { InviteUser } from '@/components/OrgUsers/InviteUser';
import { OrgUserContext } from '@/components/OrgUsers/OrgUserContext';
import UserList from '@/components/OrgUsers/OrgUserList';
import { FC, ReactElement, useContext } from 'react';

const OrgUsers: FC = (): ReactElement => {
  const { currentOrganization } = useContext(OrgUserContext);

  return (
    <div className="overflow-auto h-full">
      <div className="w-900 mx-auto content-wrapper">
        <div className="flex w-full items-center justify-left">
          <UsersIcon className="w-48 h-48" />
          <h2 style={{ fontSize: '2.5em', marginLeft: '.25em' }}>Manage Organization Users</h2>
        </div>
        <div
          className="flex flex-col p-[40px] w-full bg-[#FFFFFF] rounded-[20px] border-[1px] border-[#D3D3D3]
    ] max-h-[544px]"
          style={{ margin: '20px 0' }}
        >
          <table className="w-1/2 text-left">
            <thead>
              <tr>
                <th>Number of Admin License</th>
                <th>Number of Host License</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>{currentOrganization.numAdmin}</b> (
                  {`${currentOrganization.activeAdmins} out of ${currentOrganization.numAdmin} Users`}
                  )
                </td>
                <td>
                  <b>{currentOrganization.numHost}</b> (
                  {`${currentOrganization.activeHosts} out of ${currentOrganization.numHost} Users`}
                  )
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          className="flex flex-col p-[40px] w-full bg-[#FFFFFF] rounded-[20px] border-[1px] border-[#D3D3D3]
    ] items-center max-h-[544px]"
        >
          <div className="flex w-full items-center justify-between">
            <h2 className="text-h2">Users</h2>
            <div className="flex">
              <InviteUser
                canAddUser={currentOrganization.activeHosts < currentOrganization.numHost}
                org={currentOrganization}
                userRole={RoleType.HOST}
              />
              <InviteUser
                canAddUser={currentOrganization.activeAdmins < currentOrganization.numAdmin}
                org={currentOrganization}
                userRole={RoleType.ADMIN}
              />
            </div>
          </div>
          <UserList />
        </div>
      </div>
    </div>
  );
};

export default OrgUsers;
